export enum InvoiceDeliveryMethod {
    Electronic = 0,
    DirectDebit = 1,
    Paper = 2
}
